export const ERROR_EEI_SCORE_NOT_ACTIVATED = 'eeiScoreCopyNotActivated'
export const ERROR_EEI_SCORE_NOT_ACTIVATED_DEFAULT_COMMUNITY =
  'eeiScoreCopyNotActivatedDefaultCommunity'
